module.exports = __webpack_public_path__ + "img/SANTA CRUZ.51cbcd34.png";